/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgencyCreationRequest
 */
export interface AgencyCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyCreationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyCreationRequest
     */
    name: string;
}

/**
 * Check if a given object implements the AgencyCreationRequest interface.
 */
export function instanceOfAgencyCreationRequest(value: object): value is AgencyCreationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AgencyCreationRequestFromJSON(json: any): AgencyCreationRequest {
    return AgencyCreationRequestFromJSONTyped(json, false);
}

export function AgencyCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
    };
}

export function AgencyCreationRequestToJSON(value?: AgencyCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'name': value['name'],
    };
}

